var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block",class:_vm.type},[(_vm.type == 'alert')?_c('mdi',{attrs:{"alert":""}}):_c('mdi',{attrs:{"information-slab-circle":""}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }